import React from "react"
import { graphql } from "gatsby"
import Footer from "../components/ladakh/footer/footer"
import Header from "../components/header"
import StoriesCategory from "../components/stories/categories"
import dots from "../images/stories/dots.png"
import hamburgerMenu from "../images/stories/menu.svg"


export default function Template({
  data, // this prop will be injected by the GraphQL query below.
}) {
  const { markdownRemark } = data // data.markdownRemark holds your post data
  const { frontmatter, html } = markdownRemark
  return (
    // <div className="blog-post-container">
    //   <div className="blog-post">
    //     <h1>{frontmatter.title}</h1>
    //     <h2>{frontmatter.date}</h2>
    //     <div
    //       className="blog-post-content"
    //       dangerouslySetInnerHTML={{ __html: html }}
    //     />
    //   </div>
    // </div>
    <div className="story-content">
      <Header />
      {/*  */}
      <div className="container stories-main" id="stories">
          <div
            className="mobile-left-side left-side"
          >
            <div className="close-categori" >
              x
            </div>
            <div className="box">
              <h3>Stories</h3>
              <StoriesCategory  />
            </div>
          </div>

          {/* right */}
          <div
            className="mobile-right-side right-side"
          >
            <div className="close-categori" >
              x
            </div>
            <h3>Feedback</h3>
            <div className="user">
              <div className="top">
     
              </div>
              <i>
                Great Guides is a great concept... a must-see for anyone
                interested in travel, people, culture and nature! Thanks for all
                the hard work you've put into this incredible resource.
              </i>
            </div>
            <div className="quote">
              <h3>Quote of the Day</h3>
              <i>The secret of success is constancy to purpose.</i>
              <b>— Benjamin Disraeli</b>
            </div>
          </div>
          {/* <div className="stori-category-feedback">
            <div className="cat-story">
              <img src={hamburgerMenu} alt="menu" /> Choose Type of story,
              Country
            </div>
            <div className="feedback-small" >
              <img src={dots} alt="dots" />
            </div>
          </div> */}
          <div className="left-side">
            <div className="box">
              <StoriesCategory storiLink={true}  />
            </div>
          </div>
          <div className="middle-content middle-detail-page">
          <div className="container content">
            <div
              className="blog-post-content"
              dangerouslySetInnerHTML={{ __html: html }}
            />
          </div>
          </div>
          <div className="right-side">
            <h3>Feedback</h3>
            <div className="user">
              <div className="top">
               
              </div>
              <i>
               <b>An outstanding initiative </b> 
               <br/> I have been following the development of 'great guides' and think it is an outstanding initiative. <br/> - Prof Andy Dawes
               
              </i>
            </div>
            <div className="quote">
              <h3>Quote of the Day</h3>
              <i>The secret of success is constancy to purpose.</i>
              <b>— Benjamin Disraeli</b>
            </div>
          </div>
        </div>
      <Footer />
    </div>
  )
}

export const pageQuery = graphql`
  query($path: String!) {
    markdownRemark(frontmatter: { path: { eq: $path } }) {
      html
      frontmatter {
        date(formatString: "MMMM DD, YYYY")
        path
        title
      }
    }
  }
`
